import { useTranslation } from "react-i18next";

export default function useTranslate(path) {
  const { t } = useTranslation();

  const value = t(path, { returnObjects: true });
  console.log("useTranslate", path, value);
  if (Array.isArray(value) || typeof value === "string") {
    return value;
  } else {
    return "";
  }
}
